import React from 'react';
import PropTypes from 'prop-types';
import logoImage from '../../assets/images/polar_ace_no_bg.png';
import './BrandMark.css';

function BrandMark({ className = '', compact = false }) {
  return (
    <span className={`brand-mark ${compact ? 'brand-mark--compact' : ''} ${className}`.trim()}>
      <img src={logoImage} alt="Polar Ace" className="brand-mark__logo" />
    </span>
  );
}

BrandMark.propTypes = {
  className: PropTypes.string,
  compact: PropTypes.bool,
};

export default BrandMark;
